@if (product?.configurable_data?.options) {
  <div class="swatch-options">
    @for (
      configurableOption of product?.configurable_data?.options;
      track configurableOption.attribute_id
    ) {
      @if (configurableOption.product_attribute_code === 'color') {
        <div class="form-group">
          <label class="control-label"
            >{{ configurableOption.label }}:
            {{
              selectedValues[configurableOption.attribute_id]
                | selectedOptionLabel
                  : getSuperAttributeById(configurableOption.product_super_attribute_id)
            }}</label
          >

          <div>
            <mat-radio-group
              class="product-swatch-color"
              #matRadioGroup="ngModel"
              [required]="true"
              [disabled]="!isSuperAttributeActive(configurableOption)"
              [(ngModel)]="selectedValues[configurableOption.attribute_id]"
              (change)="
                changeOption(configurableOption.product_super_attribute_id, $event.value)
              "
            >
              @for (option of configurableOption.options; track option) {
                <mat-radio-button [value]="option.value_index">
                  <img
                    [src]="productAttributeSwatchUrl + option.image"
                    [alt]="option.label"
                  />
                </mat-radio-button>
              }
              @if (matRadioGroup.invalid && !validated) {
                <mat-error translate> Please, select an option </mat-error>
              }
            </mat-radio-group>
          </div>
        </div>
      } @else {
        <div class="form-group">
          <label class="control-label">{{ configurableOption.label }}</label>
          <mat-form-field appearance="outline">
            <mat-select
              disableOptionCentering="true"
              placeholder="Make a choice"
              [disabled]="!isSuperAttributeActive(configurableOption)"
              [(ngModel)]="selectedValues[configurableOption.attribute_id]"
              (selectionChange)="
                changeOption(configurableOption.product_super_attribute_id, $event.value)
              "
            >
              @for (option of configurableOption.options; track option) {
                <mat-option
                  [disabled]="!isOptionAvailable(configurableOption, option)"
                  value="{{ option.value_index }}"
                >
                  {{ option.label | translate | async }}
                </mat-option>
              }
            </mat-select>
            <mat-error translate>Please, select an option</mat-error>
          </mat-form-field>
        </div>
      }
    }
  </div>
}
